import { render, staticRenderFns } from "./ComplianceScans.vue?vue&type=template&id=13f52b6d&scoped=true&"
import script from "./ComplianceScans.vue?vue&type=script&lang=js&"
export * from "./ComplianceScans.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceScans.vue?vue&type=style&index=0&id=13f52b6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f52b6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13f52b6d')) {
      api.createRecord('13f52b6d', component.options)
    } else {
      api.reload('13f52b6d', component.options)
    }
    module.hot.accept("./ComplianceScans.vue?vue&type=template&id=13f52b6d&scoped=true&", function () {
      api.rerender('13f52b6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/ComplianceScans.vue"
export default component.exports